export default __webpack_public_path__ + "static/media/ImagenPrincipalDesktop.2f90adf8.png";